// extracted by mini-css-extract-plugin
export default {"InsightsFilterBarContainer":"InsightsFilterBar-module__InsightsFilterBarContainer--X6CJW"};